module.exports = __webpack_public_path__ + "static/media/Sharp-LCD-Specification-LQ150X1LX96-7-13-16.4b33d9f8.pdf";